import type { ErrorReportMetaDTO } from "@/models/dtos/error-report-meta-dto";
import { http } from "./http";
import type { CreateErrorReportRequest } from "@/models/requests/create-error-report-request";
import type { ServiceOrderDTO } from "@/models/dtos/service-order-dto";
import { notificationsService } from "./notifications-service";
import { authService } from "@/services/auth-service.ts";

class ExternalErrorReportsService {
  async getErrorReportMeta(contractId: number): Promise<ErrorReportMetaDTO> {
    const authHeader = await authService.getAuthHeader();
    return http
      .auth(authHeader)
      .url(`/external/error-reports/meta/contract/${contractId}`)
      .get()
      .fetchError((err) => notificationsService.error(err))
      .json<ErrorReportMetaDTO>();
  }

  async getErrorReportMetaByEppsusId(
    eppsusId: number | string,
  ): Promise<ErrorReportMetaDTO> {
    const authHeader = await authService.getAuthHeader();
    return http
      .auth(authHeader)
      .url(`/external/error-reports/meta/contract/eppsus/${eppsusId}`)
      .get()
      .fetchError((err) => notificationsService.error(err))
      .json<ErrorReportMetaDTO>();
  }

  async createErrorReport(
    request: CreateErrorReportRequest,
  ): Promise<ServiceOrderDTO> {
    const authHeader = await authService.getAuthHeader();
    return await http
      .auth(authHeader)
      .url(`/external/error-reports`)
      .post(request)
      .fetchError((err) => notificationsService.error(err))
      .json<ServiceOrderDTO>();
  }
}

export const externalErrorReportsService = new ExternalErrorReportsService();
